import { FlatTreeControl } from '@angular/cdk/tree';
import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { LazyTreeNode } from '../generic-tree/generic-tree-type';
import { MatTreeFlatDataSource, MatTreeFlattener } from '@angular/material/tree';

@Component({
  selector: 'app-lazy-generic-tree',
  templateUrl: './lazy-generic-tree.component.html',
  styleUrls: ['./lazy-generic-tree.component.scss']
})
export class LazyGenericTreeComponent implements OnChanges {
  @Input() nodes: LazyTreeNode[] = [];
  @Input() prekoPutanje: boolean = false;
  @Input() sacuvajExpandState: boolean = false;
  @Input() expandFirstLevel: boolean = false;
  @Output() loadChildren = new EventEmitter<LazyTreeNode>();

  //Kod lazy stabla root na startu nema decu, pa se prvi nivo expanduje tek kada se ucitaju
  private jeTrazenPrviNivo: boolean = false;
  private jeExpandovanPrviNivo: boolean = false;

  treeControl = new FlatTreeControl<LazyTreeNode>(
    node => node.level,
    node => node.expandable
  );

  transformer = (node: LazyTreeNode) => node;

  hasChild = (_: number, node: LazyTreeNode) => node.expandable;

  treeFlattener = new MatTreeFlattener(
    this.transformer,
    node => node.level,
    node => node.expandable,
    node => node.children
  );

  dataSource = new MatTreeFlatDataSource(this.treeControl, this.treeFlattener);

  constructor() { }

  ngOnChanges(changes: SimpleChanges): void {
    if (this.sacuvajExpandState) {
      this.sacuvajExpandovaneNodove();
    }

    if (changes['nodes']) {
      this.dataSource.data = this.nodes;

      if (this.sacuvajExpandState) {
        this.vratiExpandState();
      }

      if (this.expandFirstLevel) {
        this.expandujPrviNivo();
      }
    }
  }

  private expandujPrviNivo() {
    if (this.jeExpandovanPrviNivo) return;

    const root = this.treeControl.dataNodes?.find(x => x.putanjaNadredjenog == null);
    if (!root || !root.expandable) return;

    //Prvo se traze deca, a expand se radi kada stignu kroz novi nodes
    if (!root.children || root.children.length === 0) {
      if (!this.jeTrazenPrviNivo) {
        this.jeTrazenPrviNivo = true;
        this.loadChildren.emit(root);
      }
      return;
    }

    this.treeControl.expand(root);
    this.jeExpandovanPrviNivo = true;
  }

  toggleNode(node: LazyTreeNode) {
    if (this.treeControl.isExpanded(node)) {
      this.treeControl.collapse(node);
    }
    else {
      if (!node.children || node.children.length === 0) {
        this.loadChildren.emit(node);
      }
      this.treeControl.expand(node);
    }
  }

  expandedNodeIds = new Set<number>();
  expandedNodePutanje = new Set<string>();
  sacuvajExpandovaneNodove() {
    this.expandedNodeIds.clear();
    this.expandedNodePutanje.clear();

    const selected = this.treeControl.expansionModel.selected || [];
    selected.forEach((n: any) => {
      if (!n) return;
      if (this.prekoPutanje) {
        if (n.putanja) this.expandedNodePutanje.add(n.putanja);
      } else {
        if (n.id != null) this.expandedNodeIds.add(n.id);
      }
    });
  }

  vratiExpandState() {
    if (!this.treeControl.dataNodes?.length) return;

    if (this.prekoPutanje) {
      this.expandedNodePutanje.forEach(p => {
        const node = this.treeControl.dataNodes.find(n => n.putanja === p);
        if (node) this.treeControl.expand(node);
      });
    } else {
      this.expandedNodeIds.forEach(id => {
        const node = this.treeControl.dataNodes.find(n => n.id === id);
        if (node) this.treeControl.expand(node);
      });
    }
  }
}
